<template>
  <section :class="{'pl-3 pr-3': customerDetail && !customerDetail.error, 'p-3': !customerDetail || customerDetail.error}" v-if="selectedConversation">
    <i class="fas fa-sticky-note text-info"></i> โน้ตบันทึก
    <a href="" @click.prevent="editCustomerNote()"><i class="fas fa-pencil-alt"></i></a>
    <div class="py-2 text-small note-customer" v-if="!isEditing">{{ customerNote }}</div>
    <div class="py-3 text-small" v-else>
      <div class="form-group">
        <textarea class="form-control"
                  rows="4"
                  style="font-size: 15px"
                  v-model="customerNote"></textarea>
      </div>
      <button class="btn btn-primary"
              :disabled="isLoading"
              @click="saveCustomerData()">
        {{ isLoading ? 'กำลังบันทึก...' : 'บันทึก' }}
      </button>
    </div>
    <div v-if="shouldShowConversationCreatedAt" class="pt-2 text-small text-muted">
      เคสสนทนาของวันที่: {{ formattedConversationCreatedAt }}
      <template v-if="shouldShowOriginalConversationCreatedAt">
        <br>(สนทนาครั้งแรก: {{ selectedConversation.created_at | prettyDate }} )
      </template>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  props: {
    customerDetail: Object,
    selectedConversation: Object
  },
  data () {
    return {
      isEditing: false,
      customerNote: null,
      isLoading: false
    }
  },
  computed: {
    shouldShowConversationCreatedAt () {
      return this.isRecruitmentCustomerType(this.selectedConversation ? this.selectedConversation.customer_type : null) &&
        !!this.formattedConversationCreatedAt
    },
    shouldShowOriginalConversationCreatedAt () {
      return this.isRecruitmentCustomerType(this.selectedConversation ? this.selectedConversation.customer_type : null) &&
        this.isRecruitmentConversationDateShifted(this.selectedConversation ? this.selectedConversation.created_at : null)
    },
    formattedConversationCreatedAt () {
      if (!this.selectedConversation || !this.selectedConversation.created_at) {
        return ''
      }

      const conversationDate = this.getRecruitmentConversationDate(this.selectedConversation.created_at)
      if (!conversationDate.isValid()) {
        return ''
      }

      const thaiWeekdays = ['วันอาทิตย์', 'วันจันทร์', 'วันอังคาร', 'วันพุธ', 'วันพฤหัสบดี', 'วันศุกร์', 'วันเสาร์']
      const thaiMonths = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']

      return `${thaiWeekdays[conversationDate.day()]} ${conversationDate.date()} ${thaiMonths[conversationDate.month()]} ${conversationDate.year() + 543}`
    }
  },
  watch: {
    'selectedConversation.id': function (newVal, oldVal) {
      this.isEditing = false
      this.initialNoteData()
    }
  },
  methods: {
    ...mapActions('customer', ['saveCustomer']),
    isRecruitmentCustomerType (customerType) {
      return ['recruitment_customer', 'recruitment_professional', 'recruitment_professional_secondary'].includes(customerType)
    },
    isRecruitmentConversationDateShifted (createdAt) {
      const conversationDate = moment(createdAt)
      return conversationDate.isValid() && conversationDate.hour() >= 17
    },
    getRecruitmentConversationDate (createdAt) {
      const conversationDate = moment(createdAt)
      if (!conversationDate.isValid()) {
        return conversationDate
      }

      return conversationDate.hour() >= 17
        ? conversationDate.add(1, 'day')
        : conversationDate
    },
    editCustomerNote () {
      this.isEditing = true
    },
    async saveCustomerData () {
      this.isLoading = true
      const customer = {
        id: this.selectedConversation.customer.id,
        note: this.customerNote
      }
      const submitData = {
        customer: customer,
        conversation_id: this.selectedConversation.id
      }
      await this.saveCustomer(submitData)
      this.isEditing = false
      this.isLoading = false
    },
    initialNoteData () {
      if (this.selectedConversation) {
        this.customerNote = this.selectedConversation.customer.note
      } else {
        this.customerNote = null
      }
    }
  },
  mounted () {
    this.initialNoteData()
  }
}
</script>

<style lang="scss" scoped>

.note-customer {
  white-space: pre-line;
}
</style>
